export default __webpack_public_path__ + "static/media/diners-club.ffc3cc8e.svg";